<script>
    import { info } from '../store';
    import { numberFormatter } from '../functions';
    import Step2 from './Step2.svelte';

    export let step;
    export let stepComponent;

    let disabled = true;

    $: $info, checkStatus();

    function checkStatus () {
        disabled = !($info.income > 0 && $info.hours_month > 0 && $info.name.length > 2);
    }

    function next () {
        step = 2;
        stepComponent = Step2;
    }
</script>

<main>
    <div class="calculator-banometru-card active">

        <div class="subtitle color-mov text-center mb-2">Bine ai venit în</div>
        <div class="text-center color-mov mb-2">
            <h2>Simulatorul de alegeri</h2>
        </div>
        <div class="subtitle text-center color-mov">Azi vom explora rambursarea anticipată.</div>

        <div class="first-form pt-4 pb-4">
            <div class="row align-items-center">
                <div class="col-md mb-1">
                    <div class="lab">Nume</div>
                </div>
                <div class="col-md mb-3">
                    <div class="form-group">
                        <input type="text" class="form-control" bind:value="{$info.name}" required>
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col-md mb-1">
                    <div class="lab">Ce venit ai?</div>
                </div>
                <div class="col-md mb-3">
                    <div class="form-group">
                        <input type="number" class="form-control" bind:value="{$info.income}" required>
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col-md mb-1">
                    <div class="lab">Câte ore lucrezi pe lună?</div>
                </div>
                <div class="col-md mb-3">
                    <div class="form-group">
                        <input type="number" class="form-control" bind:value="{$info.hours_month}" required>
                    </div>
                </div>
            </div>
        </div>

        <div class="venit-ora-container mb-4">
            <div class="venit-ora">
                <div class="lab">Venitul tău <br>pe oră</div>
                <div class="value">
                    {numberFormatter($info.result_income_hour)}
                </div>
            </div>
        </div>

        <!-- <div class="text-center color-mov">Cum să afli din scadențar/grafic de plăți cât mai datorezi și câte luni? Cum să citești un scadențar</div> -->

        <div class="text-center pt-4">
            <button class="buton has-ico bt-next-step" disabled={disabled} on:click="{next}">Pasul următor <i class="icon-cust-arrow-circle-right"></i></button>
        </div>

    </div>
</main>
